import PasswordResetRepository, {
  RequestPasswordResetParams,
  ConfirmPasswordResetParams,
  VerifyPasswordResetTokenParams,
} from "@/repositories/password_reset_repository";
import { AxiosInstance } from "axios";
import { UnknownError } from "@/entities/errors";
import { Errors } from "@/error/error";

interface RequestPasswordResetResponse {
  message: string;
}

interface ConfirmPasswordResetResponse {
  message: string;
}

interface VerifyPasswordResetTokenResponse {
  valid: boolean;
}

export default class APIPasswordResetRepository implements PasswordResetRepository {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  private basehost = process.env.VUE_APP_BASEHOST;

  async requestPasswordReset(params: RequestPasswordResetParams): Promise<string> {
    try {
      const res = await this.client.post<RequestPasswordResetResponse>(
        `https://${this.basehost}/v1/password-reset/request`,
        {
          email: params.email,
        }
      );
      return res.data.message;
    } catch (e) {
      // セキュリティ上、メールアドレスの存在有無に関わらず同じエラーを返す
      throw new Errors().SystemError;
    }
  }

  async confirmPasswordReset(params: ConfirmPasswordResetParams): Promise<string> {
    try {
      const res = await this.client.post<ConfirmPasswordResetResponse>(
        `https://${this.basehost}/v1/password-reset/confirm`,
        {
          token: params.token,
          new_password: params.new_password,
        }
      );
      return res.data.message;
    } catch (e) {
      if (e instanceof UnknownError || e.response?.status === 400) {
        throw new Errors().InvalidToken;
      }
      throw new Errors().SystemError;
    }
  }

  async verifyPasswordResetToken(params: VerifyPasswordResetTokenParams): Promise<boolean> {
    try {
      const res = await this.client.get<VerifyPasswordResetTokenResponse>(
        `https://${this.basehost}/v1/password-reset/verify`,
        {
          params: {
            token: params.token,
          },
        }
      );
      return res.data.valid;
    } catch (e) {
      return false;
    }
  }
}
